import { gql } from '@apollo/client';

const PROJECT = `
  id
  projectName
  displayName
  projectDateStart
  projectDateEnd
  airIncluded
  carIncluded
  expenseIncluded
  hotelIncluded
  mealsIncluded
  personalCarIncluded
  railIncluded
  rideshareTaxiIncluded
  g4lAirIncluded
  projectManager
  leadAnalyst
  created
  modified
`;

export const ANALYST_MANAGER_LIST_QUERY = gql`
  query AnalystManagerList {
    analystManagerList {
      id
      nameFirst
      nameLast
    }
  }
`;

export const CREATE_PROJECT_MANAGEMENT = gql`
  mutation CreateProjectManagement($projectManagement: ProjectManagementInput!) {
    createProjectManagement(projectManagement: $projectManagement) {
      id
      projectName
    }
  }
`;

export const REPORT_TYPE_LIST_QUERY = gql`
  query ReportTypeList {
    reportTypeList {
      id
      reportType
    }
  }
`;

export const CLIENT_REPORT_MAILING_LIST_NAMES_QUERY = gql`
  query ClientReportMailingListNames($clientId: ID!) {
    clientReportMailingListNames(clientId: $clientId) {
      id
      mailingListName
      recipientCount
    }
  }
`;

export const CREATE_TTI_PROJECT_WITH_REPORT = gql`
  mutation CreateTTIProjectWithReport($projectManagement: TTIProjectReportInput!) {
    createTTIProjectWithReport(projectManagement: $projectManagement) {
      projectId
      projectReportId
    }
  }
`;

export const UPDATE_PROJECT_MANAGEMENT = gql`
  mutation UpdateProjectManagement($projectManagement: ProjectManagementInput!) {
    updateProjectManagement(projectManagement: $projectManagement)
  }
`;

export const UPDATE_TTI_PROJECT_WITH_REPORT = gql`
  mutation UpdateTTIProjectWithReport($projectManagement: TTIProjectReportUpdateInput!) {
    updateTTIProjectWithReport(projectManagement: $projectManagement)
  }
`;

export const UPDATE_TTI_PROJECT_REPORT_MAIL_SETTINGS = gql`
  mutation UpdateTTIProjectReportMailSettings($projectManagement: TTIProjectReportMailUpdateInput!) {
    updateTTIProjectReportMailSettings(projectManagement: $projectManagement)
  }
`;

export const PROJECT_LIST_QUERY = gql`
  query Projects($pagination: PaginationInput, $searchString: String, $sorting: SortingInput) {
    projects(pagination: $pagination, searchString: $searchString, sorting: $sorting) {
      results {
        ${PROJECT}
        projectTypeId
      }
      total
    }
  }
`;

export const PROJECT_QUERY = gql`
  query Project($id: ID!) {
    project(id: $id) {
      ${PROJECT}
      description
      clientDateStart
      clientDateEnd
      clientName
      baseDate
      projectTypeId
      projectReport {
        id
        reportTypeId
        reportCurrency
        reportEmail
        reportEmailBody
        reportMailingListNameId
        reportTitle
        sectionHeaderDescription
        blockFields
        hrFilterFields
        reportTableDimension
      }
    }
  }
`;

export const STATISTICS_LIST_QUERY = gql`
query Statistics($id: ID!) {
  statistics(id: $id) {
    isChosen
    dataSourceName
    co2AmountStats
    grossSpendStats
    rowsStats
  }
}
`;

export const DOWNLOAD_EMAIL_DATA_QUERY = gql`
query DownloadEmailData($projectId: ID!, $startDate: Date!, $endDate: Date!) {
  downloadEmailData(projectId: $projectId, startDate: $startDate, endDate: $endDate) {
     id
     employeeId
     clientId
     projectId
     statMonth
     dataSourceId
     totalEmissions
     firstName
     lastName
     isEmailPresent
     email
  }
}   
`;

export const PROCESS_TABLE_QUERY = gql`
query ProcessTable($id: ID!) {
  processTable(id: $id) {
      rowNum
      month
      status
      processingDate
      isProcessedAir
      isProcessedHotel
      isProcessedRail
      isProcessedCar
      isProcessedExpenses
      isProcessedMeals
      isProcessedPercar
      isProcessedTaxi
      isProcessedG4l
  }
}
`;

export const PROCESS_DATA_FUNCTION_QUERY = gql`
query ProcessData($id: ID!, $startDate: Date!, $endDate: Date!) {
  processData(id: $id, startDate: $startDate, endDate: $endDate)
}
`;

export const PUBLISH_DATA_FUNCTION_QUERY = gql`
query publishData(
  $action: String!, 
  $projectId: String!, 
  $dataSourceTags: [String]!, 
  $periodStart: [String]!, 
  $startDate: Date!, 
  $endDate: Date!,
  $projectTypeId: String!
) {
  publishData(
    action: $action, 
    projectId: $projectId, 
    dataSourceTags: $dataSourceTags, 
    periodStart: $periodStart, 
    startDate: $startDate, 
    endDate: $endDate,
    projectTypeId: $projectTypeId
  )
}
`;
